import React from 'react';
import * as CommerceEnviromentListeners from '@atlassian/commerce-environment/telemetry-listeners';
import { ChannelVersionFragmentationSafeGuard } from '@atlassian/commerce-telemetry';
export var SafeGuard = function SafeGuard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ChannelVersionFragmentationSafeGuard, {
    childPackageListenerModules: [CommerceEnviromentListeners]
  }, children);
};